// jQuery
import $ from 'jquery';
window.$ = window.jQuery = $;

// AOS (Animate on Scroll)
import AOS from 'aos';
import 'aos/dist/aos.css';
import 'swiper/css/bundle';

// Fancybox
import { Fancybox } from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox/fancybox.css';

// Match Height
import 'jquery-match-height/jquery.matchHeight';

// Sliders
import { initValuesSlider, initTeamSlider, initTestimonialsSlider, initTestimonialsCarousel, initMediaSlider } from './sliders';

// Mega Menu
import { initMegaMenu } from './mega-menu';

// Stat Counter
import { initStatCounter } from './stat-counter';

// News Archive Tabs
import { initNewsArchiveTabs } from './news-archive';

// Link List
import { initLinkList } from './link-list';

// AOS init on window load
window.addEventListener('load', () => {

    AOS.init({
        once: true,
        duration: 600,
        easing: 'ease-out',
    });

    initValuesSlider();
    initTeamSlider();
    initTestimonialsSlider();
    initTestimonialsCarousel();
    initMediaSlider();
    initMegaMenu();
    initStatCounter();
    initNewsArchiveTabs();
    initLinkList();

    // Fancybox auto-bind
    Fancybox.bind('[data-fancybox]');

    // Accordion toggle
    document.querySelectorAll('.block-accordion__item-header').forEach(btn => {
        btn.addEventListener('click', () => {
            const item = btn.closest('.block-accordion__item');
            const accordion = item.closest('.block-accordion__items');
            const isOpen = item.classList.contains('is-active');

            // Close all siblings
            accordion.querySelectorAll('.block-accordion__item.is-active').forEach(open => {
                open.classList.remove('is-active');
                open.querySelector('.block-accordion__item-header').setAttribute('aria-expanded', 'false');
            });

            // Toggle clicked (open if it wasn't already open)
            if (!isOpen) {
                item.classList.add('is-active');
                btn.setAttribute('aria-expanded', 'true');
            }
        });
    });
    // Footer nav accordion (mobile)
    const footerSmallBp = 768;
    document.querySelectorAll('.mastfoot__nav-heading').forEach((heading) => {
        heading.addEventListener('click', (e) => {
            if (window.innerWidth >= footerSmallBp) return; // allow normal link on desktop
            e.preventDefault();
            const col = heading.closest('[class*="mastfoot__nav-col"]') || heading.parentElement;
            col.classList.toggle('is-open');
        });
    });

});
